// extracted by mini-css-extract-plugin
module.exports = {"innerWrapper":"MO","tooltipWrapper":"NO","icon":"OO","tooltip":"PO","content":"QO"};